// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store.js'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

//EI组件
Vue.use(ViewUI);

//路由前置钩子
router.beforeEach((to, from, next) => {
	//PC端
	//判断登录状态
	const isLogin = sessionStorage.getItem('is_login') || undefined;
	//先判断是否是跳转至登录页
	if(to.path === '/' && isLogin === undefined){
		next({
			path:'/login'
		})
	}else if(to.path === '/login' && isLogin !== undefined){
		next({
			path:'/'
		})
	}
	
	next();
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js